/* =====================================================================
   ZGD — Que la foto no salga en negro  ·  23-sep-2026
   ---------------------------------------------------------------------
   Sintoma: al tocar una miniatura de la 5a en adelante, la foto grande
   salia NEGRA. Causa: esas <img> llevan loading="lazy" y, en el layout
   de miniaturas, el tema nunca dispara su carga al cambiar de foto.
   No es el CSS del cuadrado: se comprobo quitando el overflow y seguia.

   Arreglo: al tocar una miniatura (o al mover el carrusel) se le quita el
   lazy a la imagen que toca, y se precargan las dos siguientes para que
   el cambio se sienta instantaneo.

   ⚠️ Depende del marcado de Dawn. Si deja de funcionar, revisar:
     .thumbnail-list__item  →  cada miniatura
     .product__media-item   →  cada foto grande
   Peor caso si el tema cambia: no encuentra nada y todo queda como hoy.
   ===================================================================== */
(function () {
  function despertar(i) {
    var fotos = document.querySelectorAll('.product__media-item img');
    for (var k = i; k <= i + 2 && k < fotos.length; k++) {
      var img = fotos[k];
      if (img && img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
        /* reasignar el src obliga al navegador a bajarla ya */
        /* NO se reasigna el src: con srcset/sizes puede dejar la foto en
           blanco. Quitar el lazy basta para que el navegador la baje. */
      }
    }
  }

  function arrancar() {
    var minis = document.querySelectorAll('.thumbnail-list__item');
    if (!minis.length) return false;
    minis.forEach(function (li, i) {
      li.addEventListener('click', function () { despertar(i); }, { passive: true });
    });
    /* las dos primeras, listas de entrada */
    despertar(0);
    return true;
  }

  if (document.readyState !== 'loading') arrancar();
  else document.addEventListener('DOMContentLoaded', arrancar);
})();
